import React from 'react';
import { number } from 'prop-types';
import { MAX_REVIEW_COUNT } from './constants';
import './style.scss';

/**
 * Formats a given reviews count.
 * @param {Number} reviews The current reviews count.
 * @return {String|Number}
 */
const formatReviews = (reviews = 0) => reviews >= MAX_REVIEW_COUNT ?
    `${Math.round(reviews / MAX_REVIEW_COUNT)}k+`
    : reviews;

const Reviews = ({ reviews }) => (
    <span className="reviews">{formatReviews(reviews)}</span>
);

Reviews.propTypes = {
    reviews: number.isRequired
};

export default Reviews;
